module.exports = "<cms-grid grid-options=\"$ctrl.gridOptions\"\n          datasource=\"$ctrl.datasource\"\n          on-page-change=\"$ctrl._onPageChange($page)\"\n          initial-sort-model=\"$ctrl.initialSortModel\"\n          initial-filter-model=\"$ctrl.initialFilterModel\"\n></cms-grid>\n";


//////////////////
// WEBPACK FOOTER
// ./src/cmsCore/LogsModules/LogsGrid/logs-grid.html
// module id = 926
// module chunks = 0